module.exports = __webpack_public_path__ + "media/images/favicon/apple-touch-icon-8e6a70600920b1623df572439226ce05.png";